import React from 'react';

export default function Flag({ width = 53, height = 'auto' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.819 4.535c10.32-4.932 24.079-3.48 26.659.844v25.749s-10.788-4.012-25.77 2.127C10.724 39.395 1.6 35.488 1.6 35.488V7.708s7.764 4.213 23.219-3.173zM1.6 3.434V59.49"
        stroke="#F9F3E5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
